var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import withStyles from '@fil-react-components/with-styles';
import styles from './Cell.style';
const Cell = (_a) => {
    var { className, children, sm, md, lg, offset, auto, shrink, center, offsetRight } = _a, otherProps = __rest(_a, ["className", "children", "sm", "md", "lg", "offset", "auto", "shrink", "center", "offsetRight"]);
    return (_jsx("div", Object.assign({ className: classnames('cell', className) }, otherProps, { children: children })));
};
Cell.displayName = 'Cell';
export default withStyles(Cell, styles);
